import { PATHS } from "@/lib/router";
import { ActivityLogPage } from "./pages";

export const activityLogRoutes = [
  {
    path: PATHS.ACTIVITY_LOG,
    element: <ActivityLogPage />,
    handle: {
      permission: { resource: "activity_log", action: "view" },
      defaultView: true,
    },
  },
];
